import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { AppBar, IconButton, Toolbar, Collapse } from "@material-ui/core";
import LiveHelpIcon from "@material-ui/icons/LiveHelp";
import { NavLink } from "react-router-dom";

import ArrowDropDownCircleIcon from "@material-ui/icons/ArrowDropDownCircle";
import { Link as Scroll } from "react-scroll";

const Header = () => {
	const useStyles = makeStyles((theme) => ({
		root: {
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			height: "100vh",
			backgroundImage: `url(${process.env.PUBLIC_URL + "/img/firstbg.jpg"})`,
			backgroundRepeat: "no-repreat",
			backgroundSize: "cover",
		},
		appbar: {
			background: "rgba(75,178,115,0.9)",
			// background : 'rgba(75,178,115,0.9)',
		},
		wrapper: {
			width: "96%",
			margin: "0 auto",
			display: "flex",
			justifyContent: "space-between",
		},
		appbarTittle: {
			flexGrow: "1",
		},
		icon: {
			color: "#fff",
			fontSize: "2rem",
			margin: "0 auto",
		},
		title: {
			fontSize: "3rem",
			color: "#fff",
		},
		godown: {
			color: "#37d67a",
			fontSize: "5rem",
			animation: "scrollTop 0.5s alternate ease infinite",
		},
        petunjuk :{
            color:'white',
            textDecoration:'none',
            "&:hover":{
                color:'black'
            }
        }
	}));
	const [checked, setChecked] = useState(false);
	useEffect(() => {
		setChecked(true);
	}, []);
	const classes = useStyles();

	return (
		<div className={classes.root} id="header">
			<AppBar className={classes.appbar} elevation={0}>
				<Collapse
					in={checked}
					{...(checked ? { timeout: 1000 } : {})}
					collapseHeight={50}
				>
					<Toolbar className={classes.wrapper}>
						<h4>Program Linear</h4>
						<div style={{ display: "inline", marginTop: "5px" ,textDecoration: "none",color:'white'}}>
							<NavLink className={classes.petunjuk} to="/petunjukapp">
							<LiveHelpIcon />
								<p>Petunjuk</p>
							</NavLink>
						</div>
					</Toolbar>
				</Collapse>
			</AppBar>

			<Collapse
				in={checked}
				{...(checked ? { timeout: 1000 } : {})}
				collapseHeight={50}
			>
				<div>
					<h1 className={classes.title}>
						Selamat Datang di <br />
						Aplikasi Belajar Program Linear
					</h1>
					<Scroll to="menu-pilihan" smooth={true}>
						<IconButton>
							<ArrowDropDownCircleIcon className={classes.godown} />
						</IconButton>
					</Scroll>
				</div>
			</Collapse>
		</div>
	);
};

export default Header;
